<template>
  <div class="upload-file-item" :class="finalClass">
    <div ref="item" class="el-upload-list__item-container">
      <div class="el-upload-list__item-wrap">
        <div class="el-upload-list__item-file">
          <div class="upload-file-item__icons overflow-hidden truncate space-x-1.5">
            <label class="el-upload-list__item-status-label upload-file-item__actions">
              <base-icon-clickable v-if="canBeOpen" custom="!block" 
                :class="{ 'rotate-180': file.isOpen }" size="xsm" name="chevrondown"
                @click="handleClick" />
              <base-icon-clickable v-if="!hideDefaultActions" custom="!block" size="xsm" name="error" @click="handleRemove" />
              <!-- <div class="upload-file-item__custom-actions" v-if="[Status.SUCCESS, Status.WARNING, Status.INFO].includes(status)"> -->
                <div v-for="action in actions" :key="action.name" class="upload-file-item__action-wrap">
                  <base-icon-clickable size="xsm" :name="action.name" @click="executeActionMethod(action, 'handler')" custom="!block" 
                    class="upload-file-item__action" v-if="executeActionMethod(action, 'show') && [Status.SUCCESS, Status.WARNING, Status.INFO].includes(status)" />
                </div>
              <!-- </div> -->
            </label>
            <label v-if="!hideStatus" class="upload-file-item__status el-upload-list__item-status-label">
              <i v-if="status === Status.LOADING"
                class="upload-file-item__status-loading el-icon-upload-info el-icon-loading w-4 h-4"></i>
              <base-tooltip-icon v-else-if="filestatustext" size="xsm" :content="filestatustext"
                :customClass="`!bg-transparent !dark:hover:base-icon-${filestatus} align-text-top`"
                :type="filestatusicon" />
              <base-icon v-else size="xsm" :name="filestatusicon"
                :custom="`base-icon-${filestatus} hover:base-icon-${filestatus} dark:base-icon-${filestatus} dark:hover:base-icon-${filestatus} !bg-transparent !dark:hover:base-icon-${filestatus} align-text-top rounded-full`" />
            </label>
          </div>
          <a class="el-upload-list__item-name upload-file-item__name" @click="handleClick">
            <span class="upload-file-item__file-icon">
              <span v-if="file.tooltip">
                <base-tooltip-icon size="xsm" :content="file.tooltip" placement="top-start" type="none"
                  :icon="extensionIcon" class="inline-block"
                  customClass="!bg-transparent align-text-top rounded-none" />
              </span>
              <span v-else>
                <base-icon :name="extensionIcon" size="xsm" />
              </span>
            </span>
            {{ file.name }}
            <!-- <span v-if="file.attachment">({{ file.attachment.name }})</span> -->
          </a>
        </div>
      </div>
    </div>
    <upload-file-list v-if="canBeOpen && file.isOpen" class="zip-file-list ml-3" v-on="clickListener"
      :files="file.files" :actions="childActions" :deep="childDeep" :status-callbacks="statusCallbacks" :max-height="listHeight"
      :custom="custom" :list-name="listName" :hide-status="hideStatus" :reverse-colors="reverseColors" none-space hide-default-actions />
  </div>
</template>

<script>
// import _ from 'lodash'
import { i18n } from '@/i18n'
import icons from '@/components/icons/_iconLibrary'
import UploadFileList from '@/components/UploadFileList.vue'

import FileItem from '@/classes/files/FileItem'
import Action from '@/classes/files/Action'
import StatusCallback from '@/classes/files/StatusCallback'
import Status from '@/classes/scoped-list/Status'

export default {
  name: 'upload-file-item',
  components: {
    UploadFileList,
  },
  props: {
    file: {
      type: FileItem,
      required: true,
    },
    actions: {
      type: Array(Action),
      default: () => []
    },
    listName: {
      type: String,
      default: 'el-list'
    },
    hideDefaultActions: {
      type: Boolean,
      default: false
    },
    hideExpandAction: {
      type: Boolean,
      default: false
    },
    hideStatus: {
      type: Boolean,
      default: false
    },
    deep: {
      type: [Number, Boolean],
      default: false
    },
    statusTexts: {
      type: Object,
      default: () => ({})
    },
    statusCallbacks: {
      type: StatusCallback,
      default: () => ({})
    },
    reverseColors: {
      type: Boolean,
      default: false,
    },
    custom: {
      type: [String, Object],
      default: ''
    },
  },
  data () {
    return {
      Status: Status,
    }
  },
  created () {
    this.setFileStatus(this.file)
  },
  watch: {
    file: {
      deep: true,
      immediate: true,
      handler: 'setFileStatus'
    }
  },
  computed: {
    listHeight: function () {
      return 100 - (this.$refs.item ? (parseFloat(getComputedStyle(this.$refs.item).height) + parseFloat(getComputedStyle(this.$refs.item.closest('li.el-upload-list__item')).marginTop)) : 0)
    },
    extension: function () {
      return this.file.name.split('.').at(-1).toUpperCase()
    },
    extensionIcon: function () {
      return icons.includes(this.extension.toLowerCase())
        ? this.extension.toLowerCase()
        : 'docblack'
    },
    /** @returns {0|1|2|3|4} */
    status: function () {
      return Math.min(Math.max(this.file.estado, Status.LOADING), Status.INFO)
    },
    filestatus: function () {
      switch (this.status) {
        case Status.LOADING:
          return 'loading'
        case Status.SUCCESS:
          return 'success'
        case Status.INFO:
          return 'info'
        case Status.WARNING:
          return 'warning'
        case Status.ERROR:
        default:
          return 'error'
      }
    },
    filestatusicon: function () {
      return this.status && this.status !== Status.LOADING ? this.filestatus : 'info'
    },
    filestatustext: function () {
      switch (this.status) {
        case Status.SUCCESS:
          if (Object.hasOwnProperty.call(this.file, 'successmsg')) {
            return String(this.file.successmsg)
          }
          return i18n.t('tooltip.issued_file_ok')
        case Status.INFO:
          if (Object.hasOwnProperty.call(this.file, 'infomsg')) {
            return String(this.file.infomsg)
          }
          if (this.file.files?.length) {
            return i18n.t('tooltip.issued_any_childfile_some_optional_attachment_msg')
          }
          return i18n.t('tooltip.issued_some_optional_attachment_msg')
        case Status.WARNING:
          if (this.file.warns?.filter(x => !x.fixed).length === 1) {
            return this.file.warns.find(x => !x.fixed).warnMessage
          }
          if (this.file.files?.length) {
            return i18n.t('tooltip.issued_any_childfile_warns')
          }
          return i18n.t('tooltip.issued_file_warns')
        case Status.ERROR:
          if (this.file.validations?.length === 1) {
            return this.file.validations[0].validationMessage
          }
          if (this.file.files?.length) {
            return i18n.t('tooltip.issued_any_childfile_errors')
          }
          return i18n.t('tooltip.issued_file_errors')
        case Status.LOADING:
        default:
          return ''
      }
    },
    deepNumber: function () {
      return Math.max(Number(this.deep), 0)
    },
    childDeep: function () {
      return Math.max(this.deepNumber - 1, 0)
    },
    childActions: function () {
      return this.deepNumber > 0 ? this.actions : []
    },
    canBeOpen: function () {
      return !!(this.file.files?.length && !this.isFileLoading(this.file) && !this.hideExpandAction && this.deepNumber)
    },
    clickListener: function () {
      return this.$listeners.click ? { click: this.$listeners.click } : {}
    },
    finalClass: function () {
      return { clickable: this.canBeOpen || (!!this.$listeners.click && [Status.SUCCESS, Status.WARNING, Status.INFO].includes(this.status) && !this.file.files?.length) }
    }
  },
  methods: {
    setFileStatus: function (file) {
      switch (true) {
        case this.isFileLoading(file):
          this.$set(file, 'estado', Status.LOADING)
          break
        case this.isFileSuccess(file):
          this.$set(file, 'estado', Status.SUCCESS)
          break
        case this.isFileInfo(file):
          this.$set(file, 'estado', Status.INFO)
          break
        case this.isFileWarning(file):
          this.$set(file, 'estado', Status.WARNING)
          break
        case this.isFileError(file):
        default:
          this.$set(file, 'estado', Status.ERROR)
          break
      }
      if (file.files?.length) {
        file.files.forEach((x, i, a) => this.$set(a[i], 'path', `${file.path || file.name}/${x.name.includes('/') ? `"${x.name}"` : x.name}`))
      }
    },
    isFileLoading: function (file) {
      if (typeof this.statusCallbacks.loading === 'function') {
        return this.statusCallbacks.loading(file)
      }
      return !!file.loading
    },
    isFileError: function (file) {
      if (typeof this.statusCallbacks.error === 'function') {
        return !!((this.statusCallbacks.error(file)) || (file.files?.some(efile => this.isFileError(efile))))
      }
      return !!((!this.isFileLoading(file)) && (file.validations?.length || file.files?.some(efile => this.isFileError(efile))))
    },
    isFileWarning: function (file) {
      if (typeof this.statusCallbacks.warning === 'function') {
        return !!((this.statusCallbacks.warning(file)) || (file.files?.some(efile => this.isFileWarning(efile))))
      }
      return !!(!(this.isFileLoading(file) || this.isFileError(file)) && (file.warns?.some(x => !x.fixed) || file.files?.some(efile => this.isFileWarning(efile))))
    },
    isFileInfo: function (file) {
      if (typeof this.statusCallbacks.info === 'function') {
        return !!((this.statusCallbacks.info(file)) || (file.files?.some(efile => this.isFileInfo(efile))))
      }
      return !!(!((this.isFileLoading(file) || this.isFileError(file) || this.isFileWarning(file))) && ((!!file.infomsg && !!file.showinfo) || file.files?.some(efile => this.isFileInfo(efile))))
    },
    isFileSuccess: function (file) {
      if (typeof this.statusCallbacks.success === 'function') {
        return !!((this.statusCallbacks.success(file)) || (file.files?.some(efile => this.isFileSuccess(efile))))
      }
      return (!(this.isFileLoading(file) || this.isFileError(file) || this.isFileWarning(file) || this.isFileInfo(file)))
    },
    handleRemove: function () {
      this.$emit('remove', this.file)
    },
    handleClick: function () {
      if (this.canBeOpen) {
        this.file.isOpen = !this.file.isOpen
      } else if ([Status.SUCCESS, Status.WARNING, Status.INFO].includes(this.status) && !this.file.files?.length) {
        this.$emit('click', this.file)
      }
    },
    executeActionMethod: function (action, method = 'handler') {
      if (typeof action[method] === 'function') {
        return action[method](this.file)
      }
      this.doFeedback(i18n.t('feedback.error.unexpected_action_error', { action: `${action}.${method}(${this.file?.name})` }), 'error')
      return false
    }
  },
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

.el-upload-list__item-container {
  position: relative;
  display: flex;
}

.el-upload-list__item-file,
.el-upload-list__item-wrap {
  flex-grow: 1;
  width: 0;
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-end;
}

.el-upload-list__item-name {
  margin-right: unset;
  flex-grow: 10;
}

.upload-file-item__icons {
  display: flex;
  flex-direction: row;
  margin-right: 5px;
  overflow: visible;
  place-self: center;
}

.upload-file-item__icons .el-upload-list__item-status-label,
.upload-file-item__icons .upload-file-item__actions>* {
  position: relative;
}

.upload-file-item__icons .upload-file-item__actions>* {
  opacity: 0.75;
  color: var(--primary-500);
  right: unset;
  top: unset;
  @apply rounded-full;
}

.upload-file-item__icons .upload-file-item__actions>div {
  margin-block: auto;
}

.upload-file-item__icons .upload-file-item__actions>svg {
  top: -2px;
}

.dark .upload-file-item__icons .upload-file-item__actions>* {
  color: var(--darkblue-500);
  border-color: var(--darkblue-500);
}

.dark .upload-file-item__icons .upload-file-item__actions>*:hover {
  color: var(--darkblue-50);
  border-color: var(--darkblue-50);
  background-color: var(--darkblue-500);
}

.upload-file-item__icons .el-upload-list__item-status-label {
  right: unset;
  display: unset;
  flex-direction: row-reverse;
}

.upload-file-item__icons .el-upload-list__item-status-label>div {
  display: inline-block;
}

.upload-file-item__icons .upload-file-item__actions {
  display: none;
}

.el-upload-list__item:hover>.upload-file-item>.el-upload-list__item-container .upload-file-item__actions {
  display: flex;
}

.upload-file-item__actions>* {
  display: inline-block;
  margin-inline: 5px;
}

.upload-file-item__actions>.upload-file-item__action-wrap:not(:has(.upload-file-item__action)) {
  margin-inline: 0;
}

.upload-file-item__icons .upload-file-item__actions:has(div:hover) {
  display: flex;
}

.upload-file-item.clickable > .el-upload-list__item-container:hover {
  cursor: pointer;
}
.upload-file-item.clickable > .el-upload-list__item-container:hover .upload-file-item__name {
  color: var(--primary-500);
}

.el-upload-list__item.is-success .el-upload-list__item-name:focus,
.el-upload-list__item.is-success .el-upload-list__item-name:hover {
  color: inherit;
  cursor: inherit;
}

.el-upload-list__item.is-success .upload-file-item__icons .upload-file-item__status {
  display: unset;
}

.el-upload-list__item.is-success .upload-file-item__icons .upload-file-item__actions {
  display: none;
}
</style>
